import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { Campaign } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PublishCampaignLandingPageParams {
  id: string;
}

export const publishCampaignLandingPage = async (
  params: PublishCampaignLandingPageParams,
): Promise<Campaign> => {
  return await tinctApi.campaigns.publishLandingPage(params.id);
};

/**
 * NEW-origin campaigns only: the latest ready version of the hosted page goes
 * live with the snippet tag baked in. Synchronous (a storage copy) — the
 * returned campaign is already `published`.
 */
export const usePublishCampaignLandingPage = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, PublishCampaignLandingPageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: publishCampaignLandingPage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
